import {
  Delete as DeleteIcon,
  InsertDriveFile,
  Visibility,
} from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { AssetAttrsDetails } from "../../interfaces/api";
import DeleteAssetDocumentDialog from "../useDialogs/DeleteAssetDocumentDialog";
import { useDialogs } from "../useDialogs/useDialogs";

interface AssetDetailsProps {
  asset: AssetAttrsDetails;
  setCurrentDocId: Function;
  setDocPages: Function;
}

const AssetDetails: React.FC<AssetDetailsProps> = ({
  asset,
  setCurrentDocId,
  setDocPages,
}) => {
  const dialogs = useDialogs();
  return (
    <Stack className="gap-2 overflow-y-auto">
      {asset.documents.map((document, idx) => {
        return (
          <div
            className="flex justify-between w-full px-2 items-center"
            key={document._id}
          >
            <div className="flex">
              <InsertDriveFile className="text-gray-400" />
              <Typography className="ml-2 font-semibold">
                {document.name}
              </Typography>
            </div>
            <div className="flex">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentDocId(document._id);
                  setDocPages(undefined);
                }}
              >
                <Visibility />
              </IconButton>

              {asset.documents.length > 1 && (
                <IconButton
                  aria-label="delete"
                  onClick={async () =>
                    await dialogs.open(DeleteAssetDocumentDialog, {
                      id: document._id,
                      name: document.name,
                      assetId: asset._id,
                    })
                  }
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </div>
          </div>
        );
      })}
    </Stack>
  );
};

export default AssetDetails;
